import { Draggable } from 'react-beautiful-dnd';
import styles from './styles.module.scss'
import { Translation } from 'components/Translations/Translation';

type Props = {
	id: string
	content: string
	index: number
}

export const Element = ({ id, content, index }: Props) => (
	<Draggable draggableId={id} index={index}>
		{(provided, snapshot) => (
			<div className={`${styles.draggable_element} ${snapshot.isDragging ? styles.dragging : ''}`}
				{...provided.draggableProps}
				{...provided.dragHandleProps}
				ref={provided.innerRef}
			>
				<Translation i18n={content} />
			</div>
		)}
	</Draggable>
)
